export const TEMPLATE_APP_ICON_COUNT = 3;
